(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// ----------- Native javascript ----------- //
// legacy browser alert
var ua = navigator.userAgent;

if (ua.indexOf("MSIE 6.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 7.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 8.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 9.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else if (ua.indexOf("MSIE 10.0") != -1) {
  alert("お使いのウェブブラウザでは当サイトを正常に閲覧できません。ブラウザのバージョンを最新にして再度アクセスしてください。");
} else {} // ----------- jQuery ---------------------- //


$(function () {
  // header height cntr
  $(window).on('load resize', function () {
    var headerH = $("#header").outerHeight();
    $("#main").css({
      'margin-top': headerH + 'px'
    });
    $("#mainvisual").css({
      'height': 'calc(100vh - ' + headerH + 'px' + ')'
    });
  }); // drawer nav

  var drawerOpen = $("#hmbg");
  var drawerNav = $("#drawer");
  var drawerLayer = $("#overlay");
  var drawerClose = $("#close");
  drawerOpen.on('click', function () {
    drawerLayer.fadeIn();
    drawerNav.addClass('__open');
  });
  drawerClose.on('click', function () {
    drawerLayer.fadeOut();
    drawerNav.removeClass('__open');
  }); // scroll top

  var topBtn = $('#scroll_top');
  topBtn.css('bottom', '-100px');
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
      topBtn.stop().css({
        'bottom': '115px'
      });
    } else {
      topBtn.stop().css({
        'bottom': '-100px'
      });
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  }); // anchor scroll

  $(window).on('load resize', function () {
    var headerH = $("#header").outerHeight();
    $(".o-anc-point").css({
      'margin-top': headerH * '-1' + 'px',
      'padding-top': headerH + 'px'
    });
  });
  $('a[href*="#"].o-anchor-link').on('click', function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  }); // dropdown nav

  $(".o-megamenu-trig").each(function () {
    $(this).hover(function () {
      $(this).children('.o-megamenu-wrap').stop().slideDown();
    }, function () {
      $(this).children('.o-megamenu-wrap').stop().slideUp();
    });
  }); // accordion nav

  $(".o-accordion-trig").each(function () {
    $(this).on('click', function () {
      $(this).children('.__child').slideToggle();
      $(this).siblings().children('.__child').slideUp();
    });
  }); // change fontsize

  $("[name=fontsize-changer]").each(function () {
    $(this).on('click', function () {
      if ($("#fontsize_l").prop('checked')) {
        $("body").css({
          'cssText': 'font-size: 2.4rem !important'
        });
        $(this).parent('label').css({
          'opacity': '.5'
        });
        $(this).parent('label').siblings('label').css({
          'opacity': '1'
        });
      } else if ($("#fontsize_r").prop('checked')) {
        $("body").css({
          'font-size': '1.6rem'
        });
        $(this).parent('label').css({
          'opacity': '.5'
        });
        $(this).parent('label').siblings('label').css({
          'opacity': '1'
        });
      }
    });
  }); // tab panel

  $("#tab > li").on('click', function () {
    var i = $("#tab > li").index(this);
    $("#panel > li").hide();
    $("#panel > li").eq(i).show();
    $("#tab > li").removeClass('__active');
    $(this).addClass('__active');
  }); // post tablewrap

  $("#single_post_content table").each(function () {
    $(this).wrap('<div style="overflow: auto;"></div>');
  }); // pagettl background
  // const targetElem = document.getElementById('pagettl');
  // const targetPath = location.href;
  // case pattern 1
  // const pattern_1 = [
  //   'about',
  //   'campus',
  //   'event',
  //   'service',
  //   'application',
  //   'link',
  //   'privacy',
  //   'component',
  //   'inquiry',
  //   'kg-report'
  // ];
  // console.log(pattern_1);
  // const patternCount_1 = pattern_1.length;
  // const bg_1_url = 'url(./assets/img/site/000_common/bg-pagettl.jpg) no-repeat center center/cover';
  // case pattern XXXX
  // const pattern_XXXX = [
  //   'XXXX',
  //   'XXXX',
  //   'XXXX'
  // ];
  // const patternCount_XXXX = pattern_1.length;
  // const bg_XXXX_url = 'url(./assets/img/site/000_common/XXXXXXXX.jpg) no-repeat center center/cover';
  // for (let i = 0; i < patternCount_1; i++) {
  //   if(targetPath.includes(pattern_1[i])) {
  //     targetElem.style.background = bg_1_url;
  //   }
  // }
  // for (let i = 0; i < patternCount_XXXX; i++) {
  //   if(targetPath.includes(pattern_XXXX[i])) {
  //     targetElem.style.background = bg_XXXX_url;
  //   }
  // }
});

},{}]},{},[1]);
